import { isServer } from '@app/utils';
import { AxiosInstance } from 'axios';
import browser from './client.browser';

export default (isServer ? undefined : browser) as AxiosInstance;
